/* Complete 4x4 side cart extras (Blufire, Oct 2026). Plain script, no build step.
   "Goes with it": the newest item's checked add-ons (the same "Needed with this / Works with this" parts its product page
   lists), at their live store price, each with an Add button. Filled when the side cart opens or redraws, so pages
   that never open it never load the facts. */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const money = n => "$" + Number(n).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const shards = {};
  const load = src => shards[src] || (shards[src] = new Promise(res => {
    const s = document.createElement("script");
    s.src = src; s.async = true; s.onload = s.onerror = res;
    document.head.appendChild(s);
  }));

  async function fill() {
    const box = document.querySelector("#CartDrawer .c4p-dup:not([data-done])");
    if (!box || !box.dataset.handle || !box.dataset.src) return;
    box.dataset.done = "1";
    await load(box.dataset.src);
    const rec = (window.C4P_F || {})[box.dataset.handle];
    if (!rec || !rec.add || !rec.add.length) return;
    const inCart = new Set((box.dataset.inCart || "").split(","));
    const rows = rec.add.map(a => [a, (rec.x || {})[a.h]]).filter(([a, r]) => r && r.avail !== false && !inCart.has(a.h)).slice(0, 6);
    if (!rows.length) return;
    box.innerHTML = `<h3 class="c4p-dup__t">Goes with it</h3><div class="c4p-dup__row">${rows.map(([a, r]) => {
      const url = ROOT + "products/" + encodeURIComponent(r.h);
      // one price: add straight from here; a price range means a choice to make, so it opens the product
      const one = !r.px || r.px === r.p;
      return `<div class="c4p-dup__card">${r.img ? `<img src="${esc(r.img)}" alt="" loading="lazy" width="128" height="88">` : ""}`
        + `<span class="c4p-dup__why${a.why === "Needed for this" ? " is-need" : ""}">${esc(a.why)}</span>`
        + `<a class="c4p-dup__name" href="${url}">${esc(r.t)}</a><b>${one ? "" : "From "}${money(r.p)}</b>`
        + (one ? `<button type="button" class="c4p-dup__add" data-h="${esc(r.h)}">Add</button>` : `<a class="c4p-dup__add" href="${url}">Choose</a>`)
        + `</div>`;
    }).join("")}</div>`;
    box.hidden = false;
  }

  document.addEventListener("click", async e => {
    const b = e.target.closest && e.target.closest("button.c4p-dup__add");
    if (!b) return;
    const drawer = document.querySelector("cart-drawer");
    const box = b.closest(".c4p-dup");
    b.disabled = true;
    b.textContent = "Adding";
    try {
      const p = await (await fetch(ROOT + "products/" + encodeURIComponent(b.dataset.h) + ".js")).json();
      const v = p.variants.find(x => x.available);
      if (!v) { b.textContent = "Sold out"; return; }
      // an add-on goes the same way as the part it goes with: fitted with it, if that's being fitted
      const how = box && box.dataset.how;
      const item = { id: v.id, quantity: 1 };
      if (how && how.includes("Fitted")) item.properties = { "Fitting or delivery": how };
      const body = { items: [item] };
      const canDraw = drawer && typeof drawer.renderContents === "function";
      if (canDraw) { body.sections = drawer.getSectionsToRender().map(s => s.id); body.sections_url = location.pathname; }
      const res = await fetch(ROOT + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      if (canDraw && data.sections) {
        drawer.renderContents(data);
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") publish(PUB_SUB_EVENTS.cartUpdate, { source: "c4p-drawer", productVariantId: v.id, cartData: data });
      } else location.href = ROOT + "cart";
    } catch (err) {
      b.disabled = false;
      b.textContent = "Try again";
    }
  });

  // fill when the side cart opens, and again whenever the theme redraws it
  function watch() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;
    const go = () => { if (drawer.classList.contains("active")) fill(); };
    new MutationObserver(go).observe(drawer, { attributes: true, attributeFilter: ["class"], childList: true, subtree: true });
    go();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
})();
